import { createSlice } from '@reduxjs/toolkit';
import { useAppSelector } from './hooks';

export interface SettingsState {
    loginEnabled: boolean;
    promoEnabled: boolean;
    promos: string[];
    elastic: boolean;
    loaded: boolean;
}

const initialState: SettingsState = {
    loginEnabled: false,
    promoEnabled: false,
    promos: [],
    elastic: true,
    loaded: false,
};

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        setSettings: (state, action: { payload: Omit<SettingsState, 'loaded'> }) => {
            state.loginEnabled = action.payload.loginEnabled;
            state.promoEnabled = action.payload.promoEnabled;
            state.promos = action.payload.promos;
            state.elastic = action.payload.elastic;
            state.loaded = true;
        },
    },
});

export const { setSettings } = settingsSlice.actions;
export default settingsSlice.reducer;

export function useAppSettings(): SettingsState {
    return useAppSelector((state) => state.settings);
}
